import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Icon } from 'react-materialize'

class Header extends Component {
  render() {
    return (
      <nav>
        <div className="nav-wrapper">
          <Link to={'/'} className="brand-logo">
            <div style={{ paddingLeft: '15px' }}>
            <Icon small>chat_bubble_outline</Icon>

            </div>
          </Link>
          <ul id="nav-mobile" className="right hide-on-med-and-down">
            <li>
              <Link to={'/login'}>Login</Link>
            </li>
            <li>
              <Link to={'/about'}>About</Link>
            </li>
          </ul>
        </div>
      </nav>
    )
  }
}

export default Header
